import { FC } from 'react';
import './BarChartScale.scss';

interface BarChartScaleProps {
  length: number;
}

export const BarChartScaleLines: FC<BarChartScaleProps> = ({ length }) => {
  return (
    <div className="bar-chart-scale bar-chart-scale-lines">
      {Array.from({ length }, (_, i) => (
        <div
          key={i}
          className="bar-chart-scale__line"
          style={{ top: `${(i / length) * 100}%` }}
        />
      ))}
    </div>
  );
};
